import * as React from "react"
import IUserVm from "../../models/shared/IUserVm"
import { UserType } from "../../models/flags/UserType"
import i18n from "../../i18n/i18n"
import * as FontAwesome from "react-fontawesome"

interface ILogoutButtonComponentProps {
    user: IUserVm
}

export default class LogoutButtonComponent extends React.Component<ILogoutButtonComponentProps> {
    constructor(props: ILogoutButtonComponentProps) {
        super(props)
    }
    public render(): JSX.Element {
        const { user } = this.props

        return (
            <div className="nav-item" data-ui-test="login-name">
                <span>
                    {user.name}
                    {user.type !== UserType.Citizen && <span>, {UserType.displayName(user.type)} - {user.organization.name}</span>} <a href={process.env.LOGOUT_URL} title={i18n.t("TEXT_LOG_OUT")} data-ui-test="button-logout"><FontAwesome name="sign-out-alt" /></a>
                </span>
            </div>
        )
    }
}